import { render, staticRenderFns } from "./PointOfInterest.vue?vue&type=template&id=229b213a&"
import script from "./PointOfInterest.vue?vue&type=script&lang=ts&"
export * from "./PointOfInterest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports